export const LOCAL_STORAGE = {
  PARAMS: 'route-params'
}
